import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

function RescheduleModal({
    isOpen,
    onClose,
    onConfirm,
    appointmentId,
    item,
    loader,
}) {

    const methods = useForm({
        defaultValues: {
            reschedule_reason: '',
            date: moment().format('YYYY-MM-DD'),
            start_time: moment().format('HH:mm'),
            end_time: moment().format('HH:mm'),
        }
    });
    const { control, formState: { errors }, handleSubmit, setValue } = methods;

    useEffect(() => {

        methods.reset({ reschedule_reason: '' })

    }, [isOpen])

   useEffect(() => {
        setValue('date', item?.date || moment().format('YYYY-MM-DD'))
        setValue('start_time', item?.start_time || moment().format('HH:mm'))
        setValue('end_time', item?.end_time || moment().format('HH:mm'))
        setValue('reschedule_reason', item?.appointment_details?.reschedule_reason || '')
    }, [item, isOpen])

    return (
        <>
            <Modal isOpen={isOpen} toggle={onClose} centered className="modal-medium">
                <form action="" onSubmit={handleSubmit((data) => onConfirm(data, "reschedule"))}>
                    <ModalHeader className='header_modal align-items-center'>
                        <h5 className="modal-title_u">Reschedule Appointment</h5>
                    </ModalHeader>
                    <ModalBody className='modal_form_body' style={{ paddingTop: '10px' }}>
                        <div className='step_cards step_1'>
                            <h2 className="mb-2" style={{ margin: 0 }}>Appointment ID: {appointmentId}</h2>
                            
                            {/* DATE INPUT */}
                            <div className="row-primary align-items-center mb-2" style={{ gap: '10px' }}>
                                <h2 style={{ minWidth: '120px', margin: 0, fontSize: '15px' }}>Date*</h2>
                                <div style={{ width: '200px' }}>
                                    <Controller
                                        name="date"
                                        control={control}
                                        rules={{
                                            required: "Please select date"
                                        }}
                                        render={({ field }) =>
                                            <>
                                                <div className="input-image">
                                                    <input id='date' type="date" name='date' placeholder='Date' required
                                                        {...field}
                                                        style={{ width: '100%' }}
                                                        value={field.value ? moment(field.value).format('YYYY-MM-DD') : ""}
                                                        onChange={(e) => {
                                                            const dateString = moment((e.target.value)).format('YYYY-MM-DD')
                                                            field.onChange(dateString)
                                                        }}
                                                    />
                                                    <img src="/images/celender.png" alt="celender Icon" className="custom-icon" />

                                                </div>
                                                {errors?.date?.message &&
                                                    <div style={{ marginBottom: 5 }}>
                                                        <ErrorMessage text={errors?.date?.message} />
                                                    </div>
                                                }


                                            </>
                                        } />
                                </div>
                            </div>

                            {/* TIME INPUTS */}
                            <div className="row-primary align-items-center mb-2" style={{ gap: '20px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <h2 style={{ minWidth: '120px', margin: 0, fontSize: '15px' }}>Start Time*</h2>
                                    <div style={{ width: '160px' }}>
                                        <Controller
                                            name="start_time"
                                            control={control}
                                            rules={{
                                                required: "Please select start time"
                                            }}
                                            render={({ field }) =>
                                                <>
                                                    <div className="input-image">
                                                        <input
                                                            type="time"
                                                            name='start_time'
                                                            placeholder='hh:mm'
                                                            {...field}
                                                            style={{ width: '100%' }}
                                                            value={moment(field.value, ["h:mm A", "HH:mm"]).format("HH:mm")}
                                                            required
                                                        />
                                                        <img src="/images/clock.png" alt="Clock Icon" className="custom-icon" />
                                                    </div>
                                                    {errors?.start_time?.message &&
                                                        <div style={{ marginBottom: 5 }}>
                                                            <ErrorMessage text={errors?.start_time?.message} />
                                                        </div>
                                                    }
                                                </>
                                            }
                                        />
                                    </div>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <h2 style={{ minWidth: '80px', margin: 0, fontSize: '15px' }}>End Time*</h2>
                                    <div style={{ width: '160px' }}>
                                        <Controller
                                            name="end_time"
                                            control={control}
                                            rules={{
                                                required: "Please select end time"
                                            }}
                                            render={({ field }) =>
                                                <>
                                                    <div className="input-image">
                                                        <input
                                                            type="time"
                                                            name='end_time'
                                                            placeholder='hh:mm'
                                                            {...field}
                                                            style={{ width: '100%' }}
                                                            value={moment(field.value, ["h:mm A", "HH:mm"]).format("HH:mm")}
                                                            required
                                                        />
                                                        <img src="/images/clock.png" alt="Clock Icon" className="custom-icon" />
                                                    </div>
                                                    {errors?.end_time?.message &&
                                                        <div style={{ marginBottom: 5 }}>
                                                            <ErrorMessage text={errors?.end_time?.message} />
                                                        </div>
                                                    }
                                                </>
                                            }
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Reason */}
                            <div className="row-primary" style={{ gap: '10px' }}>
                                <h2 style={{ minWidth: '120px', margin: 0, marginTop: '5px', fontSize: '15px' }}>Reason</h2>
                                <div style={{ flex: 1 }}>
                                    <Controller
                                        name="reschedule_reason"
                                        control={control}
                                        rules={{
                                            required: "Please write reason"
                                        }}
                                        render={({ field }) =>
                                            <>
                                                <textarea
                                                    className="type_inp input-in"
                                                    {...field}
                                                    style={{ width: '100%', height: '80px' }}
                                                    placeholder='Please enter notes for Re-Scheduled ...'
                                                    required
                                                >
                                                </textarea>

                                                {errors?.reschedule_reason?.message && (
                                                    <ErrorMessage
                                                        text={errors?.reschedule_reason?.message}
                                                    />
                                                )}
                                            </>
                                        }

                                    />
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <SubmitButton buttonType="submit" className={'lightBlue'} loader={loader} btnText="Re-Schedule" />
                        <button className="table_delete" type='button' onClick={onClose}>Cancel</button>
                    </ModalFooter>
                </form>
            </Modal>

        </>
    );
}

export default RescheduleModal;